import { render, staticRenderFns } from "./account-allocation-mana.vue?vue&type=template&id=787d71df"
import script from "./account-allocation-mana.vue?vue&type=script&lang=js"
export * from "./account-allocation-mana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports